module.exports = __webpack_public_path__ + "static/media/value1.70a6d993.svg";